<template>
	<div class="link-flow-editor" v-loading="loading || p_loading">
		<vue-flow-editor
			v-bind="editorBinding"
			:toolbarButtonHandler="p_toolbarButtonHandler"
			:loading="false"
			v-on="$listeners">

			<slot name="menu" slot="menu"/>
			<slot name="toolbar" slot="toolbar"/>
			<slot name="model" slot="model"/>
			<slot name="foot" slot="foot"/>

		</vue-flow-editor>
	</div>
</template>

<script>

	import {loadVueFlowEditorDependency} from "./index";

	const Props = {
		data: {type: Object, default: () => ({})},                                          // 渲染的数据
		grid: {type: [Boolean, Object], default: true},                                     // 是否需要网格
		miniMap: {type: [Boolean, Object], default: false},                                  // 是否需要缩略图
		disabledDragEdge: {type: Boolean},                                                  // 禁用拖拽连线功能
		disabledUndo: {type: Boolean},                                                      // 禁用撤销以及重做功能
		editorTitle: {type: String, default: ' '},                                    // 禁用撤销以及重做功能

		height: {type: [String, Number], default: '100%'},                                  // 画布高度
		toolbarHeight: {type: [String, Number], default: '56'},                             // 顶部工具栏高度
		menuWidth: {type: [String, Number], default: '250'},                                // 左侧菜单栏高度
		modelWidth: {type: [Number, String], default: '500px'},                             // model 弹框的宽度

		onRef: {type: Function},                                                            // 获取引用函数
		toolbarButtonHandler: {type: Function},                                             // 工具栏按钮格式化函数
		loading: {type: Boolean},                                                           // 是否开启编辑器的loading状态

		multipleSelect: {type: Boolean, default: true},                                     // 是否可以多选

		beforeDelete: {type: Function},                                                     // 删除前校验
		afterDelete: {type: Function},                                                      // 删除后动作
		beforeAdd: {type: Function},                                                        // 添加前校验
		afterAdd: {type: Function},                                                         // 添加后动作

		activityConfig: {type: Object},                                         			// 注册活动节点
	}

	export default {
		name: "link-flow-editor",
		props: {
			...Props,
		},
		data() {
			return {
				p_loading: true,
			}
		},
		async created() {
			await loadVueFlowEditorDependency()
			this.p_loading = false
		},
		computed: {
			editorBinding() {
				return Object.keys(Props).reduce((ret, propName) => {
					ret[propName] = this[propName]
					return ret
				}, {})
			},
		},
		methods: {
			p_toolbarButtonHandler(buttons) {
				buttons = [...buttons]
				for (let i = 0; i < buttons.length; i++) {
					const button = buttons[i];
					if (button.key === 'print') {
						buttons.splice(i, 1)
						i--
					}
				}
				if (!!this.toolbarButtonHandler) {
					buttons = this.toolbarButtonHandler(buttons) || buttons
				}
				return buttons
			},
		},
	}
</script>

<style lang="scss">
	.link-flow-editor {
		height: 100%;
		width: 100%;

		.vue-flow-edit-menu-group-content {
			transition: none !important;
		}
	}
</style>